<script>
    import { fade, fly } from 'svelte/transition';
    export let message = '+50!';
</script>

<style>
    .flash-message {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 2rem;
        color: rgb(0, 255, 0);
        background: rgba(0, 0, 0, 0.7);
        padding: 1rem;
        border-radius: 0.5rem;
        z-index: 999;
    }
</style>

<div class="flash-message" in:fade={{ duration: 200 }} out:fly={{ y: -50, duration: 500 }}>
    {message}
</div>
